import Tab from '@mui/material/Tab';
import { styled } from '@mui/material/styles';
import React from 'react';


export const samePageLinkNavigation = (
  event: React.MouseEvent<HTMLDivElement, MouseEvent>,
) => {
  if (
    event.defaultPrevented ||
    event.button !== 0 || // ignore everything but left-click
    event.metaKey ||
    event.ctrlKey ||
    event.altKey ||
    event.shiftKey
  ) {
    return false;
  }
  return true;
}


interface LinkTabProps {
    label?: string;
    selected?: boolean;
}

const CustomTab = styled(Tab)(({ theme }) => ({
    textTransform: 'none',
    color: '#000',
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.pxToRem(12),
    lineHeight: theme.typography.pxToRem(14),
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 12,
    paddingBottom: 12,
    '&:hover': {
      color: `${theme.palette.primary.main} !important`,
    },
    '&:focus': {
      color: `${theme.palette.primary.main} !important`,
    },
    '&.Mui-selected': {
      color: '#000',
    },
  }));

const LinkTab = (props:LinkTabProps) => {
    return (
        <CustomTab
          onClick={(event) => {
            // Routing libraries handle this, you can remove the onClick handle when using them.
            if (samePageLinkNavigation(event)) {
              event.preventDefault();
            }
          }}
          aria-current={props.selected && 'page'}
          {...props}
        />
      );
}

export default LinkTab